import { gql, TypedDocumentNode } from '@apollo/client'
import { AppraisalLineDto, AppraisalSendEmailRequest } from '../type'

export const GetAppraisalForPage = gql`
    query GetAppraisalForPage($request: AppraisalFindRequest) {
        appraisalsFind(request: $request) {
            data {
                id
                number
                date
                appraiser {
                    id
                    name
                }
                numberOfItems
                customerKey
                customer {
                    id
                }
                customerFirstname
                customerLastname
                customerNumber
                customerEmail
                customerAddress {
                    street
                    state
                    country
                    city
                    zipCode
                    description
                    line1
                    line2
                }
                lines {
                    id
                    key
                    item {
                        id
                        sku
                        description
                    }
                    amount
                    description
                    image
                    displayOrder
                }
            }
            count
        }
    }
`

export const GetAppraisalNewNumber = gql`
    query GetAppraisalNewNumber {
        appraisalNewNumber
    }
`

export const GetAppraisalPage = gql`
    query GetAppraisalPage($number: String!) {
        appraisalPage(number: $number)
    }
`

export const GetAppraisalPrint = gql`
    query GetAppraisalPrint($id: Int!) {
        appraisalPrint(id: $id)
    }
`

export const AppraisalSendEmail: TypedDocumentNode<void, { request: AppraisalSendEmailRequest }> = gql`
    mutation AppraisalSendEmail($request: AppraisalSendEmailRequest!) {
        appraisalSendEmail(request: $request)
    }
`

export const AppraisalUpdateLines: TypedDocumentNode<void, { id: number, input: AppraisalLineDto[] }> = gql`
    mutation AppraisalUpdateLines($id: Int!, $input: [AppraisalLineDto!]!) {
        appraisalUpdateLines(id: $id, input: $input)
    }
`

export const AppraiserUpdate: TypedDocumentNode<void, { input: number[] }> = gql`
    mutation AppraiserUpdate($input: [Int!]!) {
        appraiserUpdate(input: $input)
    }
`